import { Component, OnInit } from '@angular/core';
import { RoutingPath } from '../../../../configs/routing-path';
import { IContentManager } from 'src/app/core/models/content-manager/icontent-manager';
import { LocalStorageService } from 'src/app/core/services/local-storage/local-storage.service';
import { ContentManager } from 'src/app/core/helpers/content-manager/content-manager';
import { environment } from 'src/environments/environment';
import { Title } from '@angular/platform-browser';
import { HandAccesibility} from 'src/app/core/helpers/hand-accesibility/hand-accesibility';
import { AssignOrderTab } from 'src/app/core/helpers/hand-accesibility/assign-order-tab';
import { Router } from '@angular/router';
import { Utilidades } from 'src/app/core/utils/utildades';

@Component({
  selector: 'app-retreat',
  templateUrl: './retreat.component.html',
  styleUrls: ['./retreat.component.scss']
})
export class RetreatComponent implements OnInit {

  constructor(private _storage: LocalStorageService,private title: Title,private router: Router) { }

  public urlIndividualRetiro;
  public urlMassRetiro;
  private infoContentManager: Array<IContentManager>;
  public pIndividual: IContentManager;
  public pMassive: IContentManager;
  public modal: boolean;

  ngOnInit() {
    this.title.setTitle(HandAccesibility.TitlePages.filter(a=>a.page===this.router.url)[0].title);
    this.urlIndividualRetiro = RoutingPath.appRouting.components.individual_retreat.path + '/' + RoutingPath.appRouting.components.individual_retreat.pages.home.path;
    this.urlMassRetiro = RoutingPath.appRouting.components.mass_retreat.path + '/' + RoutingPath.appRouting.components.mass_retreat.pages.home.path;
    this.infoContentManager = ContentManager.contentExtraction(
    this._storage.getItemJSON(environment.LOCAL_STORAGE.GESTOR_CONTENIDO),'dashboardRetreat','retreat');
    this.fillPIndividualPMassive();
    setTimeout(()=>{
      this.setTabIndex()}
    ,100);
  }

  fillPIndividualPMassive(){
    this.infoContentManager.forEach(val=>{
      if(val.field === 'paragraphIndividualRetreat'){
        this.pIndividual = val;
      }
      if(val.field === 'paragraphMassiveRetreat'){
        this.pMassive = val;
      }
    });
  }

  clickToggle() {
    this.modal = !this.modal;
  }

  setTabIndex(){
    let i:number; let j:number; let q:number=0; let r:number=0; let o:number=0;
    let k: number = HandAccesibility.DomObject.filter(a=>a.front==='home').length;


    //nav home, right side
    k++;
    k = AssignOrderTab.setTabsFromIndexDom(k,'home-left');

    k++;
    AssignOrderTab.setTabsFromIndexDom(k,'font-contrast');

    k++;
    k = AssignOrderTab.setTabsFromIndexDom(k,'affiliation');

    const primerElemento = document.getElementById(HandAccesibility.DomObject[HandAccesibility.INITIAL_FOCUS].object);
    Utilidades.focus(primerElemento);
  }

}
